import React, { useRef, useState, useCallback, useEffect } from "react";
import { Modal, Row, Col, Form, Select, Checkbox, Descriptions, Spin, message } from "antd";
import { connect } from "dva";

const { Option } = Select;

const notificationsOptions = [
  { key: "majorDataChange", value: 1, label: "Major data change" },
  { key: "majorMinorDataChange", value: 2, label: "Major/Minor data change" },
  { key: "minorDataChange", value: 3, label: "Minor data change" },
];

const NotificationSettings = ({ dispatch, userId, readOnly, notificationsSettings, loadingFetch, loadingSubmit }) => {
  const formRef = useRef(null);

  const [visible, setVisible] = useState(false);

  const showModal = useCallback(() => {
    setVisible(true);
  }, []);

  const onCancel = useCallback(() => {
    setVisible(false);
  }, []);

  const onFinish = useCallback(
    formData => {
      const data = {
        receiveDashboard: !!formData.receiveDashboard,
        receiveEmail: !!formData.receiveEmail,
        receiveSms: !!formData.receiveSms,
      };

      if (formData.notificationLevel !== undefined) {
        data.notificationLevel = formData.notificationLevel;
      }

      dispatch({
        type: "notifications/updateUserNotificationsSettings",
        data,
      }).then(response => {
        if (response !== undefined) {
          message.success("Notifications settings updated!");
          setVisible(false);
        }
      });
    },
    [dispatch],
  );

  const doSubmit = useCallback(() => {
    formRef.current.submit();
  }, []);

  useEffect(() => {
    if (!visible) {
      return;
    }

    dispatch({
      type: "notifications/fetchUserNotificationSettings",
      userId,
    }).then(response => {
      const { notificationLevel, receiveDashboard, receiveEmail, receiveSms } = response;

      if (!readOnly)
        formRef.current.setFieldsValue({
          notificationLevel,
          receiveDashboard,
          receiveEmail,
          receiveSms,
        });
    });
  }, [dispatch, visible, readOnly, userId]);

  return (
    <>
      <a onClick={showModal} style={{ color: "black" }}>
        Notifications settings
      </a>
      <Modal
        open={visible}
        onCancel={onCancel}
        okButtonProps={{
          loading: loadingSubmit,
          style: {
            display: readOnly ? "none" : undefined,
          },
        }}
        cancelText={readOnly ? "Close" : undefined}
        onOk={doSubmit}
      >
        <Spin spinning={loadingFetch}>
          {readOnly ? (
            <Descriptions column={1}>
              <Descriptions.Item label={<span className="light-gray-text">Notification level</span>}>
                {typeof notificationsSettings.notificationLevel === "number" ? notificationsOptions[2].label : ""}
              </Descriptions.Item>
              <Descriptions.Item label={<span className="light-gray-text">Receive Dashboard</span>}>
                {notificationsSettings.receiveDashboard ? "True" : "False"}
              </Descriptions.Item>
              <Descriptions.Item label={<span className="light-gray-text">Receive Email</span>}>
                {notificationsSettings.receiveEmail ? "True" : "False"}
              </Descriptions.Item>
              <Descriptions.Item label={<span className="light-gray-text">Receive SMS</span>}>
                {notificationsSettings.receiveSms ? "True" : "False"}
              </Descriptions.Item>
            </Descriptions>
          ) : (
            <Form ref={formRef} layout="vertical" onFinish={onFinish}>
              <Row gutter={16}>
                <Col lg={24}>
                  <Form.Item name="notificationLevel" label="Notification Level">
                    <Select
                      placeholder="Choose Notification Level"
                      getPopupContainer={trigger => trigger.parentElement}
                    >
                      {notificationsOptions.map(option => (
                        <Option key={option.key} value={option.value}>
                          {option.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col lg={8}>
                  <Form.Item name="receiveDashboard" valuePropName="checked">
                    <Checkbox>Receive Dashboard</Checkbox>
                  </Form.Item>
                </Col>
                <Col lg={8}>
                  <Form.Item name="receiveEmail" valuePropName="checked">
                    <Checkbox>Receive Email</Checkbox>
                  </Form.Item>
                </Col>
                <Col lg={8}>
                  <Form.Item name="receiveSms" valuePropName="checked">
                    <Checkbox>Receive SMS</Checkbox>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          )}
        </Spin>
      </Modal>
    </>
  );
};

export default connect(({ notifications, loading }) => ({
  settingsId: notifications.id,
  notificationsSettings: {
    notificationLevel: notifications.notificationLevel,
    receiveDashboard: notifications.receiveDashboard,
    receiveEmail: notifications.receiveEmail,
    receiveSms: notifications.receiveSms,
  },
  loadingFetch: loading.effects["notifications/fetchUserNotificationSettings"],
  loadingSubmit: loading.effects["notifications/updateUserNotificationsSettings"],
}))(NotificationSettings);
